import { num } from '../format';

export const avatarWords = {
  en: {
    title: 'Your character, your journey',
    why: 'Make it yours from day one. Earn equipment and animated styles as you clear levels.',
    latest: 'Latest rewards', next: 'Up next', complete: 'Every reward is yours. Mix your favourites.',
    progress: (n: number) => `${num(n, 'en')} ${n === 1 ? 'level' : 'levels'} cleared`,
    remaining: (n: number) => `${num(n, 'en')} more to unlock`,
    unlocked: 'Unlocked', preview: 'Try it on', previewOnly: 'Preview only — clear more levels to wear this look.',
    restore: 'Back to my look', replay: 'Replay animation', motion: 'Animate preview',
    motionWhy: 'Short animations play on profiles. Chat portraits stay still. Reduced motion follows your device setting.',
    customize: 'Customize character', newRewards: (n: number) => `${num(n, 'en')} character rewards unlocked`,
  },
  ar: {
    title: 'شخصيتك تتقدم معك',
    why: 'صمّمها على ذوقك منذ البداية. اكسب معدات وإطارات متحركة كلما أنهيت مستويات.',
    latest: 'أحدث المكافآت', next: 'المكافأة التالية', complete: 'فتحت كل المكافآت. اجمع ما يعجبك منها.',
    progress: (n: number) => n === 1 ? 'أنهيت مستوى واحدًا' : n === 2 ? 'أنهيت مستويين' : `أنهيت ${num(n, 'ar')} ${n > 10 ? 'مستوى' : 'مستويات'}`,
    remaining: (n: number) => n === 1 ? 'أنهِ مستوى آخر لفتحها' : n === 2 ? 'أنهِ مستويين آخرين لفتحها' : `أنهِ ${num(n, 'ar')} مستويات أخرى لفتحها`,
    unlocked: 'مفتوحة', preview: 'جرّبها', previewOnly: 'معاينة فقط — أنهِ مستويات أخرى لتستخدم هذا المظهر.',
    restore: 'عد إلى مظهري', replay: 'أعد الحركة', motion: 'حرّك المعاينة',
    motionWhy: 'تظهر حركات قصيرة في الملف الشخصي. تبقى صور الدردشة ثابتة. نحترم إعداد تقليل الحركة على جهازك.',
    customize: 'خصّص شخصيتك', newRewards: (n: number) => n === 1 ? 'فتحت مكافأة لشخصيتك' : n === 2 ? 'فتحت مكافأتين لشخصيتك' : `فتحت ${num(n, 'ar')} مكافآت لشخصيتك`,
  },
  de: {
    title: 'Dein Charakter wächst mit dir',
    why: 'Gestalte ihn von Anfang an. Schalte Ausrüstung und animierte Stile mit geschafften Leveln frei.',
    latest: 'Neueste Belohnungen', next: 'Als Nächstes', complete: 'Alle Belohnungen gehören dir. Kombiniere deine Favoriten.',
    progress: (n: number) => `${num(n, 'de')} Level geschafft`,
    remaining: (n: number) => `Noch ${num(n, 'de')} bis zur Freischaltung`,
    unlocked: 'Freigeschaltet', preview: 'Anprobieren', previewOnly: 'Nur Vorschau — schaffe weitere Level, um diesen Look zu tragen.',
    restore: 'Zurück zu meinem Look', replay: 'Animation wiederholen', motion: 'Vorschau animieren',
    motionWhy: 'Kurze Animationen spielen im Profil. Chat-Porträts bleiben still. Die Einstellung für reduzierte Bewegung wird berücksichtigt.',
    customize: 'Charakter gestalten', newRewards: (n: number) => `${num(n, 'de')} Charakter-Belohnungen freigeschaltet`,
  },
  ja: {
    title: '成長とともに、自分らしいキャラクターへ',
    why: '最初から自分らしく。レベルをクリアすると装備やアニメーション付きスタイルが解放されます。',
    latest: '最近の報酬', next: '次の報酬', complete: 'すべての報酬を解放しました。お気に入りを組み合わせましょう。',
    progress: (n: number) => `${num(n, 'ja')}レベルをクリア`,
    remaining: (n: number) => `あと${num(n, 'ja')}レベルで解放`,
    unlocked: '解放済み', preview: '試着する', previewOnly: 'プレビューのみ — このスタイルを使うには、さらにレベルをクリアしてください。',
    restore: '自分のスタイルに戻す', replay: 'アニメーションを再生', motion: 'プレビューを動かす',
    motionWhy: 'プロフィールでは短いアニメーションを再生します。チャットの画像は静止したままです。端末の視差効果を減らす設定に従います。',
    customize: 'キャラクターをカスタマイズ', newRewards: (n: number) => `${num(n, 'ja')}個のキャラクター報酬を解放`,
  },
};
